<!--
  Implementation

  -in template:
  <slotted-expancion-panel :title="//i18nkey"
                           :icon="//iconsting"
                           :helpertext="//helperText"
                           :disabled="//your extra rule || disabled">

    <template v-slot:header> //optional
      // Your header
    </template>

    <template v-slot:content>
      // Your content
    </template>

  </slotted-expancion-panel>


  -import:
  import SlottedExpancionPanel from "@/views/layouts/SlottedExpancionPanel.vue";

-->

<template>
  <v-expansion-panel :disabled="disabled">
    <slot name="header">
      <expancion-header :title="title"
                        :icon="icon"
                        :helpertext="helpertext"
                        :loading="loading">
        <template v-slot:hint>
          <slot name="header-hint" />
        </template>
      </expancion-header>
      <slot name="header-outer" />
    </slot>
    <v-expansion-panel-content>
      <v-divider />
      <slot name="content">
        <p class="mx-4 my-3">No content</p>
      </slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>


<script>
import ExpancionHeader from "@/components/ExpancionPanels/Parts/ExpancionHeader.vue";

export default {
  name: "SlottedExpancionPanel",
  props: ["title", "icon", "helpertext", "disabled", "loading"],
  components: { ExpancionHeader },

  data: () => ({}),

  created() {},

  mounted() {
    
  },

  methods: {},

  computed: {},
};
</script>

<style lang="scss">
.v-expansion-panels--flat {
  border-bottom: 1px solid rgb(218, 218, 218);
  border-radius: 0;
}
.v-expansion-panels--flat .v-expansion-panel-header {
  border-top: 1px solid rgb(218, 218, 218);
  padding: 12px 16px;
}
</style>